<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showAddGoal"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-auto w-full overflow-x-scroll"
      >
        <div
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/3 w-full m-auto"
        >
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base font-bold">Add Objective</p>
            <img
              v-if="!loading"
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="inputError"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ inputError }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">

            <div class="text-sm ">
              <label class="block pb-1">Strategic Goal</label>
              <select
                  v-model="info.StrategicGoalId"
                  class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option disabled> Select Strategic Goal</option>
                <option
                    v-for="goal in strategicGoals"
                    :key="goal.Id"
                    :value="goal.Id"
                >
                  {{ goal.Name }}
                </option>
              </select>
              <!-- {{ strategicGoals }} -->

            </div>
          </div>
          <div class="mt-2 p-4" v-if="info.StrategicGoalId">
            <!-- {{ strategicGoals }} -->
            <label class="block pb-1">Strategic Goal Details</label>
            <textarea
                v-model="StrategicGoalDescription"
                class="p-2 bg-gray-200 rounded-xl w-full"
                disabled
                rows="4"
            ></textarea>
          </div>
          <!-- {{ info }} -->
          <div class="grid grid-cols-2 sm:grid-cols-3 p-4 gap-5">
            <!-- Strategic Goal (Dropdown) -->


            <div class="text-sm">
              <label class="block pb-1">Goal Name</label>
              <input
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Goal Name"
                v-model="info.GoalName"
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Start Date</label>
              <input
                type="date"
                class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
                v-model="info.StartDate"
                :min="activePeriodStartDate"
                readonly
              />
            </div>

            <div class="text-sm">
              <!-- {{ activePeriodObjectiveDeadline }} -->
              <label class="block pb-1">End Date</label>
              <input
                type="date"
                class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
                v-model="info.EndDate"
                :disabled="!info.StartDate"
                readonly
              />
            </div>

            <div class="text-sm">
              <label class="block pb-1">Goal Measure</label>
              <div
                class="flex flex-wrap gap-2 justify-between bg-gray-200 rounded-md px-2"
                style="padding-top: 0.7rem; padding-bottom: 0.6rem"
              >
                <label class="b-contain">
                  <span>Number</span>
                  <input
                    type="radio"
                    name="measure"
                    value="number"
                    v-model="info.GoalMeasure"
                  />
                  <div class="b-input"></div>
                </label>
                <label class="b-contain">
                  <span>Text</span>
                  <input
                    type="radio"
                    name="measure"
                    value="text"
                    v-model="info.GoalMeasure"
                  />
                  <div class="b-input"></div>
                </label>
                <label class="b-contain">
                  <span>Date</span>
                  <input
                    type="radio"
                    name="measure"
                    value="date"
                    v-model="info.GoalMeasure"
                  />
                  <div class="b-input"></div>
                </label>
              </div>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Target</label>
              <input
                :type="info.GoalMeasure"
                placeholder="Target"
                v-model="info.Target"
                class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
              />
            </div>

            <div class="text-sm">
              <!-- <div class="flex"> -->
              <label class="block pb-1">Goal Weight</label>
              <!-- </div> -->
              <input
                :value="displayValue"
                @input="onInput"
                @focus="onFocus"
                @blur="onBlur"
                required
                type="text"
                class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
              />
            </div>
          </div>
          <div class="p-4">
            <label class="block pb-1">Description</label>
            <textarea
              v-model="info.Description"
              class="p-2 bg-gray-200 rounded-xl w-full"
              rows="4"
            ></textarea>
          </div>
          <div class="flex justify-end">
            <div class="flex justify-end p-5">
              <button
                class="bg-gray-400 hover:bg-primary rounded-full px-5 text-sm text-white py-3"
                @click="saveData('Draft')"
              >
                Save Draft
              </button>
            </div>
            <div class="flex justify-end p-5">
              <button
                class="bg-primary rounded-full px-5 text-sm text-white py-3"
                @click="saveData('Submitted')"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  name: 'AddGoal',
  props: ['showAddGoal', 'refresh', "handleAddCallback"],

  data() {
    return {
      loading: false,
      targetType: '',
      selectedType: 'single',
      GoalMeasure: '',
      reviewPeriodName:'',
      info: {
        GoalName: '',
        GoalMeasure: '',
        StartDate: '',
        EndDate: '',
        Target: '',
        Description: '',
        Weight: '',
        GoalWeight: '',
        CustomWeight: null,
        StrategicGoalId: null,
      },
      strategicGoals: [],
      reviewPeriods: [],
      activePeriodStartDate: '',
      activePeriodObjectiveDeadline: '',
      activePeriod: null,
      inputError: null,
      isFocused: false,
      rawInput: '',
      StrategicGoalDescription: '',
    };
  },
  computed: {
    ...mapGetters(['getOrganization', 'getToken']),
    displayValue() {
      // Display raw input when focused, formatted percentage when blurred
      return this.isFocused ? this.rawInput : `${this.info.GoalWeight}%`;
    },
  },
  created() {
    this.getPerformancePeriodSetups();

  },
  watch: {
    inputError() {
      setTimeout(() => {
        this.inputError = '';
      }, 3000);
    },
    'info.StrategicGoalId'(newId) {
      if (newId) {
        this.StrategicGoalDescription = this.strategicGoals.find(
          (stg) => stg.Id == newId
        )?.Description;
      } else {
        this.StrategicGoalDescription = '';
      }
    },
  },

  methods: {
    clearCustomWeight() {
      this.info.CustomWeight = null;
    },
    clearGoalWeight() {
      this.info.GoalWeight = null;
    },
    toggleGoalMeasure(type) {
      this.targetType = type;

      this.info.GoalMeasure = type;
    },
    close() {
      this.$emit('close');
      this.info = {
        GoalName: '',
        GoalMeasure: '',
        StartDate: '',
        EndDate: '',
        Target: '',
        Description: '',
        Weight: '',
        GoalWeight: null,
        CustomWeight: null,

      };
    },
    saveData(type) {
      this.$emit("refresh-list");
      if (
        !this.info.GoalName ||
        !this.info.GoalMeasure ||
        !this.info.StartDate ||
        !this.info.EndDate ||
        !this.info.Target
      ) {
        this.$notify.error({
          title: 'Failure',
          message: `Please fill in all required fields`,
        });
        return;
      }

      // Prepare the data to be sent to the server

      const data = {
        GoalName: this.info.GoalName,
        GoalMeasure: [
          this.info.GoalMeasure.split('').slice(0, 2)[0].toUpperCase(),
          ...this.info.GoalMeasure.split('').slice(1),
        ].join(''),
        StartDate: this.info.StartDate,
        EndDate: this.info.EndDate,

        Target:
          this.info.GoalMeasure.toLowerCase() === 'date'
            ? moment(this.info.Target).format('DD/MM/yyyy')
            : this.info.Target,
        Description: this.info.Description,
        Weight: this.info.CustomWeight
          ? this.info.CustomWeight
          : this.info.GoalWeight,
        StrategicGoalId: this.info.StrategicGoalId,
        SubmissionStatus:type
      };

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      axios
        .post(
          `${this.getOrganization}/performance/objective/mine/${this.$ApiVersion}/add`,
          data,
          options
        )
        .then((response) => {
          if (response.data.StatusCode == 200) {
            this.$notify({
              title: 'Success',
              message: response.data.StatusMessage,
              type: 'success',
            });
            this.$emit('close');
            this.getPerformancePeriodSetups()
            window.location.reload()
          } else {
            this.$notify.error({
              title: 'Failure',
              message: response.data.StatusMessage,
            });
          }
        })
        .catch((error) => {
          console.error('Error saving data:', error);
        });
    },

    // performance/period/v1/request
    getPerformancePeriodSetups() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.reviewPeriods = response.data.Data;
            this.activePeriod = this.reviewPeriods.find(
              (period) => period.Active == true
            );

            this.info.StartDate = this.activePeriod.StartDate.split("T")[0]
            this.info.EndDate = this.activePeriod.EndDate.split("T")[0]
            this.getStrategicGoals();
          } else {
            this.$notify.error({
              title: 'Failure',
              message: response.StatusMessage,
            });
          }
        },
        (error) => {
          this.loading = false;
          this.$notify.error({ title: 'Failure', message: error.message });
        }
      );
    },
    onInput(event) {
      let value = event.target.value;

      // Remove non-numeric characters except for a single decimal point
      value = value.replace(/[^0-9.]/g, '');

      // Ensure only one decimal point is allowed
      const decimalIndex = value.indexOf('.');
      if (decimalIndex !== -1) {
        // Keep only the first decimal point and remove others
        value =
          value.slice(0, decimalIndex + 1) +
          value.slice(decimalIndex + 1).replace(/\./g, '');
      }

      // Convert to number
      let numericValue = parseFloat(value);

      if (numericValue > 100) {
        this.inputError = 'Weight cannot exceed 100%';
        setTimeout(() => {
          this.rawInput = '';
          this.info.GoalWeight = '';
        }, 2000);
      }

      // Ensure it's a multiple of 5
      // if (numericValue % 5 !== 0) {
      //   numericValue = Math.round(numericValue / 5) * 5;
      // }

      // Update raw input and model
      this.rawInput = isNaN(numericValue) ? '' : numericValue.toString();
      this.info.GoalWeight = isNaN(numericValue) ? 0 : numericValue;
    },
    onFocus() {
      // On focus, show the raw input value
      this.isFocused = true;
      this.rawInput = this.info.GoalWeight.toString();
    },
    onBlur() {
      // On blur, show the formatted value
      this.isFocused = false;
    },

    getStrategicGoals() {
      // alert(1);
      this.loading = true;
      let url = `${this.getOrganization}/performance/strategic/goal/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
        (response) => {
          this.loading = false;
          if (response.data.StatusCode == 200) {
            this.strategicGoals = response.data.Data.filter(
                (goal) =>  goal.ReviewPeriod === this.activePeriod.Name
            );

            this.tableData = this.strategicGoals;
          } else {
            this.get_error = response.data.StatusMessage;
          }
        },
        (error) => {
          this.loading = false;
          this.get_error = error.message;
        }
      );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
